var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmilieImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 113,
    viewBox: "0 0 112 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.631836,
    width: 111,
    height: 111,
    rx: 15.5,
    fill: "#EEF4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.631836,
    width: 111,
    height: 111,
    rx: 15.5,
    stroke: "#C7D7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0004 49.4652C48.0004 48.3606 47.105 47.4652 46.0004 47.4652C44.8959 47.4652 44.0004 48.3606 44.0004 49.4652H48.0004ZM44.0004 52.7985C44.0004 53.9031 44.8959 54.7985 46.0004 54.7985C47.105 54.7985 48.0004 53.9031 48.0004 52.7985H44.0004ZM68.0004 49.4652C68.0004 48.3606 67.105 47.4652 66.0004 47.4652C64.8959 47.4652 64.0004 48.3606 64.0004 49.4652H68.0004ZM64.0004 52.7985C64.0004 53.9031 64.8959 54.7985 66.0004 54.7985C67.105 54.7985 68.0004 53.9031 68.0004 52.7985H64.0004ZM45.526 63.0651C44.7527 62.2763 43.4865 62.2638 42.6977 63.037C41.9089 63.8103 41.8963 65.0765 42.6696 65.8653L45.526 63.0651ZM69.3307 65.8653C70.104 65.0765 70.0914 63.8103 69.3026 63.037C68.5139 62.2638 67.2476 62.2763 66.4743 63.0651L69.3307 65.8653ZM56.0004 84.6322C40.2603 84.6322 27.5004 71.8723 27.5004 56.1322H23.5004C23.5004 74.0814 38.0511 88.6322 56.0004 88.6322V84.6322ZM84.5004 56.1322C84.5004 71.8723 71.7405 84.6322 56.0004 84.6322V88.6322C73.9496 88.6322 88.5004 74.0814 88.5004 56.1322H84.5004ZM56.0004 27.6322C71.7405 27.6322 84.5004 40.3921 84.5004 56.1322H88.5004C88.5004 38.183 73.9496 23.6322 56.0004 23.6322V27.6322ZM56.0004 23.6322C38.0511 23.6322 23.5004 38.183 23.5004 56.1322H27.5004C27.5004 40.3921 40.2603 27.6322 56.0004 27.6322V23.6322ZM44.0004 49.4652V52.7985H48.0004V49.4652H44.0004ZM64.0004 49.4652V52.7985H68.0004V49.4652H64.0004ZM56.0002 67.4652C51.8969 67.4652 48.1902 65.7828 45.526 63.0651L42.6696 65.8653C46.0551 69.3188 50.7788 71.4652 56.0002 71.4652V67.4652ZM66.4743 63.0651C63.8101 65.7828 60.1034 67.4652 56.0002 67.4652V71.4652C61.2215 71.4652 65.9452 69.3188 69.3307 65.8653L66.4743 63.0651Z",
    fill: "#4C60E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilieImg);
export default __webpack_public_path__ + "static/media/smilieImg.a9f8630936d4fa936b0d8b26559a58f2.svg";
export { ForwardRef as ReactComponent };